import React, { useState } from "react";
import { Form, Button, Card, Alert, Spinner, Row, Col } from "react-bootstrap";
import axios from "../context/AxiosInstance";
import "./VerificationPage.css";

const VerificationPage = () => {
  const [formData, setFormData] = useState({
    matricule: "",
    mois: "",
    annee: "",
    code_bulletin: ""
  });

  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const moisOptions = [
    "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
    "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
  ];

  const annees = [2024, 2025, 2026];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.matricule || !formData.mois || !formData.annee || !formData.code_bulletin) {
      setError("Veuillez remplir tous les champs, y compris le mot de passe du bulletin (à demander à l'employé)");
      return;
    }

    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const response = await axios.get("/verification/salaire/", {
        params: {
          matricule: formData.matricule,
          mois: formData.mois,
          annee: parseInt(formData.annee),
          code_bulletin: formData.code_bulletin,
        }
      });

      if (response.data.success) {
        setResult(response.data.data);
        setError(null);
      } else {
        setError(response.data.message);
        setResult(null);
      }
    } catch (err) {
      console.error("Erreur API:", err);
      if (err.code === 'ERR_NETWORK') {
        setError("❌ Erreur de connexion : Impossible de joindre le serveur. Vérifiez que le backend est démarré.");
      } else if (err.response?.status === 404) {
        setError("❌ Endpoint non trouvé : L'API de vérification n'est pas disponible.");
      } else if (err.response?.data?.detail) {
        setError(`❌ Erreur serveur : ${err.response.data.detail}`);
      } else {
        setError("❌ Erreur inattendue : Impossible de traiter votre demande.");
      }
      setResult(null);
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setFormData({
      matricule: "",
      mois: "",
      annee: "",
      code_bulletin: ""
    });
    setResult(null);
    setError(null);
  };

    return (
    <div className="verification-page">
             {/* Navbar blanche */}
       <nav className="navbar navbar-light bg-white shadow-sm">
         <div className="container-fluid m-0 p-0">
           <div className="navbar-brand d-flex align-items-center justify-content-center w-100">
             <img 
               src="/aguipex_logo.png" 
               alt="Logo Aguipex" 
               height="50"
               className="mx-auto"
             /> 
           </div>
         </div>
       </nav>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            {/* En-tête simplifié */}
            <div className="text-center mb-4">
              <h2 className="fw-bold text-white mb-3">🔍 Vérification de Salaire</h2>
              <p className="text-white-50 fs-5">
                Entrez votre matricule, le mois et l'année pour vérifier votre bulletin
              </p>
            </div>

            {/* Formulaire */}
            <Card className="shadow-sm">
              <Card.Body className="p-4">
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          📋 Matricule *
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="matricule"
                          value={formData.matricule}
                          onChange={handleChange}
                          placeholder="Entrez votre matricule"
                          className="form-control-lg"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          🔐 Mot de passe du bulletin (demandez-le à l'employé) *
                        </Form.Label>
                        <Form.Control
                          type="password"
                          name="code_bulletin"
                          value={formData.code_bulletin}
                          onChange={handleChange}
                          placeholder="Saisissez le mot de passe du bulletin"
                          className="form-control-lg"
                        />
                        <Form.Text className="text-muted">
                          Pour protéger la confidentialité, seul l'employé connaît ce mot de passe.
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          📅 Mois *
                        </Form.Label>
                        <Form.Select
                          name="mois"
                          value={formData.mois}
                          onChange={handleChange}
                          className="form-select-lg"
                        >
                          <option value="">Sélectionner un mois</option>
                          {moisOptions.map((mois) => (
                            <option key={mois} value={mois}>{mois}</option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          📊 Année *
                        </Form.Label>
                        <Form.Select
                          name="annee"
                          value={formData.annee}
                          onChange={handleChange}
                          className="form-select-lg"
                        >
                          <option value="">Sélectionner une année</option>
                          {annees.map((annee) => (
                            <option key={annee} value={annee}>{annee}</option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>

                  <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    <Button
                      type="button"
                      variant="outline-secondary"
                      onClick={handleReset}
                      className="me-md-2"
                    >
                      🔄 Réinitialiser
                    </Button>
                    <Button
                      type="submit"
                      variant="primary"
                      disabled={loading}
                      className="px-4"
                    >
                      {loading ? (
                        <>
                          <Spinner animation="border" size="sm" className="me-2" />
                          Vérification...
                        </>
                      ) : (
                        "🔍 Vérifier"
                      )}
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>

                         {/* Message d'erreur */}
             {error && (
               <Alert variant="danger" className="mt-3">
                 <div className="text-center">
                   <strong className="fs-5">❌ Erreur</strong>
                   <br />
                   <span className="fs-6">{error}</span>
                 </div>
               </Alert>
             )}

            {/* Résultat */}
            {result && (
              <Card className="mt-4 shadow-sm border-success">
                <Card.Header className="bg-success text-white">
                  <h5 className="mb-0">✅ Informations de Salaire</h5>
                </Card.Header>
                <Card.Body className="p-4">
                  <Row>
                    <Col md={6}>
                      <div className="mb-3">
                        <strong className="text">👤 Nom complet :</strong>
                        <div className="fw-bold fs-5">
                          {result.nom} {result.prenom}
                        </div>
                      </div>
                      <div className="mb-3">
                        <strong className="text">🆔 Matricule :</strong>
                        <div className="fw-bold">{result.matricule}</div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <strong className="text">🏢 Département :</strong>
                        <div className="fw-bold">{result.departement}</div>
                      </div>
                      <div className="mb-3">
                        <strong className="">📅 Période :</strong>
                        <div className="fw-bold">{result.mois} {result.annee}</div>
                      </div>
                    </Col>
                  </Row>
                  
                  <hr />
                  
                                     <div className="text-center">
                     <div className="mb-2">
                       <strong className="">💰 Montant Net :</strong>
                     </div>
                     <div className="display-6 fw-bold text-success">
                       {result.salaire_net_formatted}
                     </div>
                   </div>
                </Card.Body>
              </Card>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationPage;
